import { render, staticRenderFns } from "./TemporaryPrivacy.vue?vue&type=template&id=f3e54264&scoped=true"
import script from "./TemporaryPrivacy.vue?vue&type=script&lang=js"
export * from "./TemporaryPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e54264",
  null
  
)

export default component.exports